<template>
    <div/>
</template>

<script>
    export default {
        props: {
            channel: null
        },
        data() {
            return {
                connected: false,
                client: null
            }
        },
        created() {
          this.client = window.ablyClient;
        },
        mounted() {
            let obj = this;
            if (this.client.connection.state === 'connected') {
                this.emitState(true);
            }
            this.client.connection.on('connected', () => {
                obj.emitState(true);
            });
            this.client.connection.on('failed', (e) => {
                obj.emitState(false);
            });
            const channel = this.client.channels.get('public:' + this.channel);
            channel.subscribe((message) => {
                this.$emit('message', message);
            });
      },
      methods: {
          emitState(state) {
              this.connected = state;
              this.$emit('connected', state);
          }
      }
    }
</script>
